module.exports = __webpack_public_path__ + "img/jobmule_categorie.d38f9958.png";